<template>
    <div>
        <div class="home-btn d-none d-sm-block">
            <router-link to="/" class="text-dark">
                <i class="mdi mdi-home-variant h2"></i>
            </router-link>
        </div>
        <div class="account-pages my-5 pt-sm-5">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="text-center">
                            <router-link to="/" class="mb-5 d-block auth-logo">
                                <img
                                    src="@/assets/images/phl_logo.png"
                                    alt
                                    height="22"
                                    class="logo logo-dark"
                                />
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="row align-items-center justify-content-center">
                    <div class="col-md-8 col-lg-6 col-xl-5">
                        <div class="card">
                            <div class="card-body p-4">
                                <div class="text-center mt-2">
                                    <h5 class="text-primary">Welcome Back !</h5>
                                    <p class="text-muted">
                                        Sign in to continue
                                        <span v-if="form.isOAuth"
                                            >access with
                                            <b>{{
                                                form.oauth.clientName
                                            }}</b></span
                                        >.
                                    </p>
                                </div>
                                <div class="p-2 mt-4">
                                    <div
                                        v-if="
                                            notification && notification.message
                                        "
                                        :class="
                                            'alert alert-' + notification.type
                                        "
                                    >
                                        {{ notification.message }}
                                    </div>

                                    <b-form
                                        data-testid="login-form"
                                        @submit="tryToLogIn"
                                    >
                                        <b-form-group
                                            id="email"
                                            class="mb-3"
                                            label="Email or Username"
                                            label-for="input-1"
                                        >
                                            <b-form-input
                                                data-testid="login-email"
                                                id="email"
                                                v-model="form.email"
                                                type="text"
                                                placeholder="Enter email or username"
                                                :class="{
                                                    'is-invalid':
                                                        v$.email.$errors.length,
                                                }"
                                            ></b-form-input>
                                            <b-form-invalid-feedback
                                                id="input-3-feedback"
                                                v-for="error of v$.email
                                                    .$errors"
                                                :key="error.$uid"
                                            >
                                                <span
                                                    data-testid="login-email-validation"
                                                    v-if="
                                                        error.$validator ===
                                                        'required'
                                                    "
                                                >
                                                    Please enter your email or
                                                    username
                                                </span>
                                                <span v-else>
                                                    {{ error.$message }}
                                                </span>
                                            </b-form-invalid-feedback>
                                        </b-form-group>

                                        <b-form-group
                                            id="input-group-2"
                                            class="mb-3"
                                        >
                                            <div class="float-end">
                                                <router-link
                                                    to="/forgot-password"
                                                    class="text-muted"
                                                    >Forgot password?
                                                </router-link>
                                            </div>
                                            <label for="password"
                                                >Password</label
                                            >
                                            <b-form-input
                                                data-testid="login-password"
                                                id="password"
                                                v-model="form.password"
                                                type="password"
                                                placeholder="Enter password"
                                                :class="{
                                                    'is-invalid':
                                                        v$.password.$errors
                                                            .length,
                                                }"
                                            ></b-form-input>
                                            <b-form-invalid-feedback
                                                id="input-3-feedback"
                                                v-for="error of v$.password
                                                    .$errors"
                                                :key="error.$uid"
                                            >
                                                <span
                                                    data-testid="login-password-validation"
                                                    v-if="
                                                        error.$validator ===
                                                        'required'
                                                    "
                                                >
                                                    Please enter your password
                                                </span>
                                                <span v-else>
                                                    {{ error.$message }}
                                                </span>
                                            </b-form-invalid-feedback>
                                        </b-form-group>

                                        <div class="form-check">
                                            <input
                                                type="checkbox"
                                                class="form-check-input"
                                                id="auth-remember-check"
                                            />
                                            <label
                                                class="form-check-label"
                                                for="auth-remember-check"
                                                >Remember me</label
                                            >
                                        </div>

                                        <div
                                            class="mt-3 float-start"
                                            v-if="form.isOAuth"
                                        >
                                            <button
                                                class="btn btn-danger w-sm"
                                                @click="onOAuthCancel"
                                            >
                                                Cancel
                                            </button>
                                        </div>

                                        <div class="mt-3 float-end">
                                            <button
                                                type="submit"
                                                variant="primary"
                                                class="btn btn-primary w-sm"
                                                data-testid="login-submit"
                                                :disabled="
                                                    form.loading ||
                                                    (form.isOAuth &&
                                                        !form.oauth.isValid)
                                                "
                                            >
                                                <span v-if="form.loading">
                                                    <b-spinner
                                                        small
                                                    ></b-spinner>
                                                    Loading...
                                                </span>
                                                <span v-if="!form.loading">
                                                    Log In
                                                </span>
                                            </button>
                                        </div>
                                    </b-form>
                                </div>
                                <!-- end card-body -->
                            </div>
                            <!-- end card -->
                        </div>
                        <div class="mt-5 text-center">
                            <p>
                                © {{ new Date().getFullYear() }} Platcorp
                                Holdings Limited
                            </p>
                        </div>
                        <!-- end row -->
                    </div>
                    <!-- end col -->
                </div>
                <!-- end row -->
            </div>
        </div>
    </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required, minLength, helpers } from '@vuelidate/validators';
import appConfig from '@/app.config';
import { mapActions, useStore } from 'vuex';
import { computed, onBeforeMount, onMounted, reactive } from 'vue';
import { userService } from '@/services/user.service';
import { oauthService } from '@/services/oauth.service';
import { userActivityLoggerService } from '@/services/userActivityLogger.service';
import { v4 as uuidv4 } from 'uuid';
import { useRoute } from 'vue-router';
import db from '@/services/pouchDb';
import _ from 'lodash'
/** import {useUserStore} from '@/composables/compUser'; **/

/**
 * Login component
 */
export default {
    page: {
        title: 'Login',
        meta: [
            {
                name: 'description',
                content: appConfig.description,
            },
        ],
    },
    
    methods: {
        ...mapActions({
            notificationSuccess: 'notification/success',
            notificationError: 'notification/error',
        }),
        /**  Deactivate for now as this is not the correct routine. This just checks all successful logins for all users in the system */
        async getData(){
            const { data } = await userActivityLoggerService.getLoginHistoryCount();
            this.state.total = data.history[0].count;
   
            if(this.state.total == 1 ){
                //Redirect to reset password
                this.$router.push('/profile/change-password');               
            }

        },


        // Try to log the user in with the username
        // and password they provided.
        async tryToLogIn() {
            // stop here if form is invalid
            this.v$.$touch();
           
            

            // return;
           
            if (this.v$.$invalid) {
                return;
            }
        
            const { email, password } = this.form;
            if (email && password) {                
                                    
                    this.form.loading = true;
                try {
                    const userResult = await userService.login(email, password);
                   
                        // trackUsers Login Location
                    if (userResult.data.success && userResult.status==200);
                    {
                        let userId =  userResult.data.data.Id;
                        userActivityLoggerService.createTracking(uuidv4(), userId, 'login');

                    }
                    


                    // if (userResult.status === 203) {
                    //     router.push({ path: 'token', query: { email, initial: userResult.data.initial } });
                    //     this.loading = false;
                    //     return;
                    // }
                    try {
                        userResult.data.data.isOAuth = this.form.isOAuth;
                        userResult.data.data.oauth = this.form.oauth;
                    } catch(error) {
                        console.log(error)
                    }
                    await this.$store.dispatch(
                        'auth/login',
                        userResult.data.data,
                    );
                    if (!db.userDB || _.isEmpty(db.userDB)) {
                        db.userDB = db.refreshUserDb();
                    }
                    if (navigator.onLine) {
                        let current;
                        try {
                            current = await db.authDB.get(
                                userResult.data.data.Id,
                            );
                        } catch(error) {
                            console.log(error)
                        }
                        let userObj = {
                            _id: userResult.data.data.Id,
                            user: userResult.data.data,
                        };
                        if (current) {
                            userObj['_rev'] = current['_rev'];
                        }
                        db.authDB.put(userObj);
                        // this.getData();
                
                    }
                } catch (error) {
                    console.log("ERROR", error);
                    let err = error;
                    if (error.response) {
                  
                        try {
                            err = error.response.data.error;
                            if (
                                error.response.status === 400 ||
                                error.response.status === 429
                            ) {
                                err =
                                    error.response.data.error.message ||
                                    error.response.data.error[0].msg;
                            }
                        } catch {
                            err =
                                'Unable to login offline, please login while online before attempting to login offline.';
                        }
                    }
                    // Just an example of how to sent error to bugsnag
                    this.notificationError(err);
                }
            }
            // const theUser = await this.useComp.login(email, password, this.form.isOAuth, this.form.oauth);
            // console.log(theUser);
            
            this.form.loading = false;
           
         
        },
    },

    setup() {
        const store = useStore();
        const route = useRoute();
        const state = reactive({
            total:0,
        });
        // const useComp = useUserStore();        
        const form = reactive({
            email: '',
            password: '',
            loading: false,
            isOAuth: route.name === 'login-oauth',
            oauth: {
                isValid: true,
                clientName: '',
                clientId: '',
                clientSecret: '',
                redirectUri: '',
            },
        });

   

        const getClient = async (id, secret) => {
            try {
                const res = await oauthService.getClient(id, secret);
                if (res.success === true && res.data.length > 0) {
                    const client = res.data[0];
                    form.oauth.clientName = client.name;

                    if (client.redirectUri !== form.oauth.redirectUri) {
                        form.oauth.isValid = false;
                        store.dispatch(
                            'notification/error',
                            'Incorrect redirect uri provided',
                        );
                    }
                } else {
                    form.oauth.isValid = false;
                    store.dispatch(
                        'notification/error',
                        'Invalid client id/secret provided',
                    );
                }
            } catch (error) {
                this.notificationError('There was a problem fetching clients');
            }
        };

        const onOAuthCancel = () => {
            window.location.href = `${form.oauth.redirectUri}?success=false&msg=user_cancelled_request`;
        };

        const notification = computed(() => {
            return store ? store.state.notification : null;
        });

        const notificationAutoCloseDuration = computed(() => {
            return store && store.state.notification ? 5 : 0;
        });

        // eslint-disable-next-line no-unused-vars
        const onBiometricAuthSuccess = async () => {
            let refreshToken = localStorage.getItem('refreshToken');
            const userResult = await userService.biometricAuth(refreshToken);
            await store.dispatch('auth/login', userResult.data);
        }
        // eslint-disable-next-line no-unused-vars
        const onBiometricAuthError = () => {
            store.dispatch('notification/error', 'Invalid fingerprint');
        };

        onMounted(() => {
            document.body.classList.add('authentication-bg');
            localStorage.setItem('impersonationStatus','null');
        });

        onBeforeMount(() => {
            if (form.isOAuth) {
                form.oauth.clientId = route.query.client_id;
                form.oauth.clientSecret = route.query.client_secret;
                form.oauth.redirectUri = route.query.redirect_uri;

                getClient(form.oauth.clientId, form.oauth.clientSecret);
            }
        });

        const rules = computed(() => ({
            email: {
                required: helpers.withMessage(
                    'Email or username is required',
                    required,
                ),
            },
            password: {
                required,
                minLength: minLength(8),
            },
        }));

        const v$ = useVuelidate(rules, form);

        return {
            state,
            form,            
            v$,
            state,
            notification,
            notificationAutoCloseDuration,
            onOAuthCancel,
        };
    },
};
</script>

<style lang="scss" module></style>
